import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UAParser } from 'ua-parser-js';
import { isPlatformBrowser } from '@angular/common';
import { AppServiceFeatureFlagsService } from 'src/app/services/app-service-feature-flags/app-service-feature-flags.service';

@Component({
  selector: 'android-app-banner',
  templateUrl: './android-app-banner.html',
  styleUrls: ['./android-app-banner.scss']
})

export class AndroidAppBanner implements OnInit{
  bannerClosed = false;
  bannerVisible = false;
  parser = new UAParser();
  isBrowser: boolean;
  disableiOS = false;
  disableAndroid = false;

  constructor(
    public appServiceFeatureFlags: AppServiceFeatureFlagsService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.disableiOS = this.appServiceFeatureFlags.isIOSBannerDisabled();
    this.disableAndroid = this.appServiceFeatureFlags.isAndroidBannerDisabled();
  }

  ngOnInit(): void {
    if (this.isBrowser && sessionStorage.getItem('bannerClosed')) {
      this.bannerClosed = true;
    }
    const oSCheck = this.parser.getOS();

    if ((oSCheck.name === "iOS" && !this.disableiOS) || (oSCheck.name === "Android" && !this.disableAndroid)) {
      this.bannerVisible = true
    }
  }

  closeBanner() {
    this.bannerClosed = true;
    if (this.isBrowser) {
      sessionStorage.setItem('bannerClosed', 'true');
    }
  }

  openMobileApp() {
    if (!this.isBrowser) return;
    window.location.href = `${environment.apiUrl}/mobile`;
  }

}
